import { Pipe } from '@angular/core';
import { isObject } from '../helpers/helpers';
var InvertPipe = (function () {
    function InvertPipe() {
    }
    InvertPipe.prototype.transform = function (obj) {
        if (Array.isArray(obj) || !isObject(obj)) {
            return obj;
        }
        return Object.keys(obj)
            .reduce(function (o, k) {
            return Object.assign(o, (_a = {}, _a[obj[k]] = k, _a));
            var _a;
        }, {});
    };
    InvertPipe.decorators = [
        { type: Pipe, args: [{ name: 'invert' },] },
    ];
    /** @nocollapse */
    InvertPipe.ctorParameters = function () { return []; };
    return InvertPipe;
}());
export { InvertPipe };
//# sourceMappingURL=invert.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/object/invert.js
// module id = 271
// module chunks = 4